import { render } from "./BulkPatientUploadOverlay.vue?vue&type=template&id=8cff064c&scoped=true&lang=pug"
import script from "./BulkPatientUploadOverlay.vue?vue&type=script&lang=js"
export * from "./BulkPatientUploadOverlay.vue?vue&type=script&lang=js"

import "./BulkPatientUploadOverlay.vue?vue&type=style&index=0&id=8cff064c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cff064c"]])

export default __exports__